// extracted by mini-css-extract-plugin
module.exports = {"squareLayout":"index-module--squareLayout--3mi91","imageEllipse":"index-module--imageEllipse--36TKc","imageRectangel":"index-module--imageRectangel--3GJXP"};